// extracted by css-extract-rspack-plugin
export default {"vacation":"MaskSize_vacation__10o21","projectTime":"MaskSize_projectTime__DjYRf","timeTracking":"MaskSize_timeTracking__ZgaOi"};